export default "/react/sberIcon-8defc9af.svg";